import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=e1d63866&scoped=true&"
var script = {}
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=e1d63866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d63866",
  null
  
)

export default component.exports